var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":_vm.color,"text-color":"white","small":""}},[_c('v-avatar',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_vm._v("\n    "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }